(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hesatek-compact-lead-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hesatek-compact-lead')) {
    customElements.define('hesatek-compact-lead', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        const status = this.querySelector('[role="status"]');
        const submitButton = form?.querySelector('button[type="submit"]');
        const submitLabel = submitButton?.querySelector('span');

        if (!form || !status || !submitButton || !submitLabel) return;

        const startedAt = Date.now();
        const requestId = this.createRequestId();
        const originalSubmitLabel = submitLabel.textContent;
        const messageField = form.elements.namedItem('message');
        const mobileMessageQuery = window.matchMedia('(max-width: 767px)');
        const fieldValue = (name) => {
          const field = form.elements.namedItem(name);
          return field && 'value' in field ? String(field.value).trim() : '';
        };
        const resizeMessage = () => {
          if (!(messageField instanceof HTMLTextAreaElement)) return;
          if (!mobileMessageQuery.matches) {
            messageField.style.height = '';
            messageField.style.overflowY = '';
            return;
          }
          messageField.style.height = 'auto';
          const maxHeight = 132;
          messageField.style.height = `${Math.min(Math.max(messageField.scrollHeight, 52), maxHeight)}px`;
          messageField.style.overflowY = messageField.scrollHeight > maxHeight ? 'auto' : 'hidden';
        };

        mobileMessageQuery.addEventListener('change', resizeMessage);
        resizeMessage();

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }

          if (this.dataset.previewOnly === 'true') {
            status.dataset.state = 'success';
            status.hidden = false;
            status.focus();
            return;
          }

          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitLabel.textContent = this.dataset.sendingText || originalSubmitLabel;
          status.hidden = true;

          let succeeded = false;
          try {
            const response = await fetch(this.dataset.endpoint || '/apps/hesatek-tarjouspyynto', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                requestId,
                startedAt,
                source: 'service-form',
                website: fieldValue('website'),
                pageUrl: fieldValue('source_url'),
                locale: this.dataset.locale || 'fi',
                service: fieldValue('service'),
                contact: {
                  name: fieldValue('name'),
                  email: fieldValue('email'),
                  phone: fieldValue('phone'),
                  postalCode: fieldValue('postal_code'),
                  message: fieldValue('message'),
                },
              }),
            });
            const payload = await response.json().catch(() => null);
            if (!response.ok || !payload || payload.ok !== true) {
              const failure = new Error('request_failed');
              failure.status = response.status;
              throw failure;
            }

            succeeded = true;
            this.dispatchEvent(new CustomEvent('hesatek:lead-received', { bubbles: true }));
            try {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'tarjouspyynto_form_fill',
                form_type: 'service_form',
                service: fieldValue('service'),
                source_path: window.location.pathname,
              });
            } catch (analyticsError) {
              console.warn('[hesatek-compact-lead] Analytics event failed', analyticsError);
            }
            window.location.assign(this.dataset.successUrl || '/pages/tarjouspyynnon-vahvistus');
          } catch (error) {
            status.dataset.state = 'error';
            status.textContent = error?.status === 429
              ? this.dataset.rateLimitText
              : error?.status === 409
                ? this.dataset.processingText
                : this.dataset.errorText;
            status.hidden = false;
            status.focus();
          } finally {
            if (!succeeded) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');
              submitLabel.textContent = originalSubmitLabel;
            }
          }
        });

        form.addEventListener('input', (event) => {
          status.hidden = true;
          if (event.target === messageField) resizeMessage();
        });
      }

      createRequestId() {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hesatek-published-ago"] && !Shopify.designMode) return;
  try {
    (() => {
  const units = [[31536000, 'year'], [2592000, 'month'], [604800, 'week'], [86400, 'day'], [3600, 'hour'], [60, 'minute']];
  const formatters = new Map();
  const update = () => {
    if (typeof Intl.RelativeTimeFormat !== 'function') return;
    const now = Date.now() / 1000;
    document.querySelectorAll('time[data-relative-published]').forEach(time => {
      const timestamp = Number(time.dataset.relativePublished);
      if (!Number.isFinite(timestamp) || timestamp <= 0) return;
      const elapsed = Math.max(0, now - timestamp);
      if (elapsed < 60) {
        time.textContent = time.dataset.justNow;
        return;
      }
      const locale = time.dataset.timeLocale || document.documentElement.lang || 'fi';
      if (!formatters.has(locale)) formatters.set(locale, new Intl.RelativeTimeFormat(locale, { numeric: 'always', style: 'long' }));
      const [seconds, unit] = units.find(([seconds]) => elapsed >= seconds);
      time.textContent = time.dataset.publishedLabel + ' ' + formatters.get(locale).format(-Math.floor(elapsed / seconds), unit);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
})();
  } catch(e) { console.error(e); }
})();

})();
